import Vue from 'vue';

export interface FactorySelectOption {
  value: number;
  displayText: string;
  domesticSourceOfGood?: string;
}

export const FactoryDomesticSourceMixin = Vue.extend({
  data() {
    return {
      factorySelectOptions: [] as FactorySelectOption[]
    };
  },
  methods: {
    async loadFactorySelectOptions() {
      const options = await this.$store.dispatch({
        type: 'system/factory/getFactorySelectOptions'
      });
      this.factorySelectOptions = options || [];
    },
    onFactoryChange(factoryId: number, row: any) {
      if (!factoryId || factoryId <= 0) {
        row.factoryId = 0;
        row.domesticSourceOfGood = '';
        row.factoryName = '';
        return;
      }
      const option = this.factorySelectOptions.find(x => x.value === factoryId);
      row.factoryId = factoryId;
      row.domesticSourceOfGood = option ? (option.domesticSourceOfGood || '') : '';
      row.factoryName = option ? option.displayText : '';
    },
    getFactoryDisplayName(row: any) {
      if (row.factoryName) {
        return row.factoryName;
      }
      if (row.factoryId > 0) {
        const option = this.factorySelectOptions.find(x => x.value === row.factoryId);
        return option ? option.displayText : '';
      }
      return '';
    }
  }
});
